var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "visitor-welcome-wrap", style: _vm.bgColor },
    [
      _vm.requireWhiteListing
        ? _c("visitor-login", { on: { callback: _vm.visitorLoginCallback } })
        : [
            _c("transition", { attrs: { name: "fade" } }, [
              _vm.currentModal !== "login"
                ? _c(
                    "div",
                    {
                      staticClass: "visitor-welcome",
                      on: {
                        click: function ($event) {
                          if ($event.target !== $event.currentTarget)
                            return null
                          return _vm.closeHandler.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("VisitorProfileMobile", {
                        staticClass: "visitor-profile-mobile-position",
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "visitor-welcome-container bg-light" },
                        [
                          _c("visitor-step1", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.visitorPageStep === 1,
                                expression: "visitorPageStep === 1",
                              },
                            ],
                            on: { callback: _vm.visitorStep1Callback },
                          }),
                          _vm._v(" "),
                          _c("visitor-step2", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.visitorPageStep === 2,
                                expression: "visitorPageStep === 2",
                              },
                            ],
                            ref: "visitorStep2",
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.requireWhiteListing
                        ? _c("VisitorProfileDesktop", {
                            staticClass: "visitor-profile-position",
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }